import { Box, SelectChangeEvent } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { CarrierFactory } from '../../common/carrierConfig/carrierFactory';
import { UserOrganization } from '../../common/constants/userOrganization';
import { IFilter } from '../../common/interfaces/IFilter';
import { ProductFactory } from '../../common/productConfig/productFactory';
import { AuthContext } from '../login/AuthWrapper';
import { FilterSelect } from './FilterSelect';

export const TaskListFilters = ({
  carrierFilter,
  setCarrierFilter,
  typeFilter,
  setTypeFilter,
}: {
  carrierFilter: IFilter[];
  setCarrierFilter: (filters: IFilter[]) => void;
  typeFilter: IFilter[];
  setTypeFilter: (filters: IFilter[]) => void;
}) => {
  const auth = useContext(AuthContext);
  const [carrierFilterOptions, setCarrierFilterOptions] = React.useState(
    [] as IFilter[],
  );
  const [typeFilterOptions] = React.useState([
    { value: 'PIA', label: 'Post Issue Audit' },
    { value: 'RUW', label: 'Refer to  underwriting' },
  ]);

  const handleCarrierChange = (event: SelectChangeEvent<IFilter[]>) => {
    const value = event?.target?.value;
    if (!value || typeof value === 'string') return;
    setCarrierFilter(value);
  };

  const handleTypeChange = (event: SelectChangeEvent<IFilter[]>) => {
    const value = event?.target?.value;
    if (!value || typeof value === 'string') return;
    setTypeFilter(value);
  };

  useEffect(() => {
    if (carrierFilterOptions.length === 0) {
      const carriers = ProductFactory.getCarriersByOrganization(
        auth.userOrganization as UserOrganization,
      );
      if (carriers) {
        const carrierFilters = carriers.map(carrier => ({
          value: carrier,
          label: CarrierFactory.getCarrierConfig(carrier)?.getLabel() ?? '',
        }));
        setCarrierFilterOptions(carrierFilters);
      }
    }
  }, [auth]);

  return (
    <Box display="flex" flexDirection="row">
      <Box mr={0.5}>
        <FilterSelect
          filterName="Type"
          options={typeFilterOptions}
          selected={typeFilter}
          onChange={handleTypeChange}
        />
      </Box>
      <FilterSelect
        filterName="Carrier"
        options={carrierFilterOptions}
        selected={carrierFilter}
        onChange={handleCarrierChange}
      />
    </Box>
  );
};
